import { CSSProperties } from 'react';

export interface VideoCreatorTemplateInitialState extends CSSProperties {
    width: string;
    height: string;
}

export interface VideoCreatorTemplateKeyFrame extends CSSProperties {
    duration?: number;
}

export enum VideoCreatorResourceType {
    text = 'text',
    image = 'image',
    overlay = 'overlay',
    duration = 'duration',
    sequence = 'sequence'
}

export interface VideoCreatorTemplateScene {
    id: string;
    resourceId?: string;
    resourceType: VideoCreatorResourceType;
    text?: string;
    sequenceFramesNumber?: number;
    sequenceUrlTemplate?: string;
    sequenceImageUrls?: string;
    initialState: VideoCreatorTemplateInitialState;
    keyframes: VideoCreatorTemplateKeyFrame[];
}

export interface VideoCreatorTemplate {
    id?: string;
    name?: string;
    width?: number;
    height?: number;
    duration: {
        min: number;
        max: number;
        default: number;
        current: number;
    };
    scenes: VideoCreatorTemplateScene[];
}

export interface TemplateListItem {
    id: string;
    name: string;
    header1_placeholder: string;
    text1_placeholder: string;
    text2_placeholder: string;
    button1_placeholder: string;
    imageUrl: string;
    gifUrl?: string;
    tags: string[];
}

export interface VideoCreatorImageData {
    id: string;
    url: string;
}
